import { fillActionTypeModifier } from "./reduxUtils";
import { Func2 } from "redux";


export const concatActionTypeEx = (key, prefix) => key.includes('{modifier}')
    ? fillActionTypeModifier(key, prefix)
    : concatActionType(key, prefix);

const buildWrapFn = (fn: Func2<string, string, string>) => <T>(typesObj: T, prefix: string): T => {
    const obj: any = {};
    for (let key in typesObj)
        obj[key] = concatActionTypeEx(<any>typesObj[key], prefix);
    return obj;
};

export function concatActionType(...args: string[]) {
    return args
        .filter(x => x && x.length > 0)
        .join('_');
}

export const wrapActionTypesEx = buildWrapFn(concatActionTypeEx);

export const wrapActionTypes = buildWrapFn(concatActionType);
